import { inject as service } from '@ember/service';
import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';

import GroupStore from 'mewe/stores/group-store';
import fetchGroup from 'mewe/fetchers/fetch-group';
import GroupCountersStore from 'mewe/stores/group-counters-store';
import GroupApi from 'mewe/api/group-api';
import fetchGroupCounters from 'mewe/fetchers/fetch-group-counters';
import FunctionalUtils from 'mewe/shared/functional-utils.js';
import { ds } from 'mewe/stores/ds';
import { getGroupScheduledFeed, checkGroupPendingFeed, checkGroupScheduledFeed } from 'mewe/fetchers/fetch-feed';

export default Route.extend({
  theme: 'group',

  queryParams: {
    isFirstGroupOpening: {
      refreshModel: false,
    },
    previewContext: {
      refreshModel: false,
    },
  },

  routing: service('-routing'),
  dynamicDialogs: service(),

  model(params) {
    const isFirstGroupOpening = params.isFirstGroupOpening || this.hash === '#new';

    const groupId = params.group_id;
    const eventsId = `upcoming-${groupId}`;

    const notFoundCallback = () => {
      FunctionalUtils.error(__('Group is not available'));
      this.routing.transitionTo('app.myworld', []);
    };
    const singlePostParams = this.paramsFor('app.group.single-post');
    const doneCallback = () => {
      GroupApi.groupVisited(groupId);

      const group = GroupStore.getState({ id: groupId });
      const fetchPending = !group || group.isConfirmed == true;

      if (fetchPending) {
        checkGroupPendingFeed(groupId);
        checkGroupScheduledFeed(groupId);
      }
    };

    fetchGroup(groupId, {
      notFoundCallback: notFoundCallback,
      doneCallback: doneCallback,
      postId: singlePostParams.post_id,
    });

    GroupStore.send('repositionGroupToTop', groupId);

    fetchGroupCounters(groupId);

    return EmberObject.create({
      isFirstGroupOpening: isFirstGroupOpening,
      groupId: params.group_id,
      group: GroupStore.getState({ id: groupId }),
      app: this.modelFor('app'),
      scheduledFeed: getGroupScheduledFeed(groupId),
      groupUpcomingEvents: ds.events.for(eventsId),
      counters: GroupCountersStore.getState({ id: groupId }),
      membersSearchSort: 'recency', // default value from `sortMembersOptions`
      membersSearch: null,
    });
  },

  actions: {
    didTransition() {
      window.scrollTo(0, 0);

      this.dynamicDialogs.closeAll();

      this.cleanRouteHash();
      this.controller.previewContextCopy = this.controller.previewContext;

      this.controller.setProperties({
        isFirstGroupOpening: null,
        previewContext: null,
      });
      return true;
    },
  },
});
